<template>
  <nav>
    <nav v-if="isMobile" class="operations-dropdown">
      <div class="operation-options_wrapper">
        <button
          @click="$emit('toggleShowEvents')"
          class="operation-options-button">
          <font-awesome-icon icon="chevron-left" class="chevron-icon-left"/>
        </button>
        <b-dropdown
          :text="spellOperation(operation)"
          toggle-class="operations-dropdown__dropdown"
          menu-class="operations-dropdown__menu"
        >
          <b-dropdown-item
            v-for="(operationType, index) of operationList"
            :key="index"
            link-class="operations-dropdown__dropdown-item"
            :active="operationType === operation"
            :to="event && event.id ?
              `/events/${event.id}/${operationType}` : `events/${operationType}`"
          >
            {{spellOperation(operationType)}}
          </b-dropdown-item>
        </b-dropdown>
      </div>
      <button
        @click="$emit('toggleOptionsPanel')"
        class="operation-options-button">
        <img src="../../assets/img/info-button.svg" alt="">
      </button>
    </nav>
    <b-nav v-if="!isMobile" class="operations">
      <b-nav-item
        v-for="(operationType, index) of operationList"
        :key="index"
        link-classes="operations__operation navbar-link"
        active-class="navbar-link_active"
        :active="operationType === operation"
        :to="event && event.id ?
          `/events/${event.id}/${operationType}` : `/events/${operationType}`"
      >
        {{ spellOperation(operationType) }}
      </b-nav-item>
      <b-nav-item
        v-b-toggle.events-sidebar
        class="events-sidebar__button-item"
      >
        <burger-button
          :is-dark="true"
          class="events-sidebar__button">
        </burger-button>
      </b-nav-item>
    </b-nav>
  </nav>
</template>

<script>

import BurgerButton from '../BurgerButton/BurgerButton';

export default {
  name: 'OperationsNavbar',
  components: {
    BurgerButton,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    operation: {
      type: String,
      default: 'my-share',
      validate: (value) => this.operationList.includes(value),
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      operationList: ['transactions', 'my-share', 'debts'],
    };
  },
  methods: {
    spellOperation(operation) {
      let res = '';
      if (operation === 'transactions') {
        res = this.$t('CP.transactions');
      } else if (operation === 'my-share') {
        res = this.$t('CP.myShare');
      } else if (operation === 'debts') {
        res = this.$t('CP.debts');
      }
      return res;
    },
  },
};
</script>

<style lang="scss">
  .operations, .operations-dropdown {
    height: 63px;
  }
  .operations {
    border-bottom: 1px solid #E6ECF8;
    padding: 0 17px;
  }

  .operations__operation {
    display: flex;
    align-content: center;
    color: var(--text-main-color);
    padding: 0;
    height: 62px;
  }

  .operations__operation.active {
    color: var(--btn-primary);
    border-bottom: 2px solid var(--btn-primary);
  }

  .navbar-link {
    color: var(--text-main-color);
    text-decoration: none;
    padding: 28px 17px 12px;
  }

  .navbar-link_active {
    color: var(--btn-primary);
  }

  .operations-dropdown {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 63px;
    padding: 0 16px;
    border-bottom: 1px solid #E6ECF8;
  }
  .operations-dropdown__dropdown {
    color: var(--btn-primary) !important;
    background-color: #FFFFFF !important;
    border: none;
  }
  .operations-dropdown__menu {
    padding: 0;
  }
  .operations-dropdown__dropdown-item,
  .operations-dropdown__dropdown-item:hover,
  .operations-dropdown__dropdown-item:focus {
    height: 35px;
    color: var(--text-main-color);
    background: #FFFFFF;
  }
  .operations-dropdown__dropdown-item:active,
  .operations-dropdown__dropdown-item.active,
  .operations-dropdown__dropdown-item:hover {
    color: var(--text-main-color);
    background: #F3F6FD !important;
  }
  /*.operations-dropdown__dropdown-item {*/
  /*  color: var(--text-main-color);*/
  /*}*/
  /*.operations-dropdown__dropdown-item-active {*/
  /*  color: var(--btn-primary) !important;*/
  /*  background-color: #FFFFFF !important;*/
  /*}*/
  .operation-options_wrapper {
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .operation-options-button{
      margin: 0 0.5em;
    }
    .chevron-icon-left {
      color: var(--btn-primary);
      width: 10px;
      height: 18px;
      vertical-align: middle;
    }
  }
  .operation-options-button {
    background-color: #FFFFFF;
    border: none;
    outline: none;
    width: 23px;
    height: 23px;
    box-sizing: border-box;
    padding: 0;
    border-radius: 50%;
  }
  .events-sidebar__button-item {
    display: none;
    outline: none;
    align-self: center;
    margin-left: auto;
  }
  .events-sidebar__button {
    background-color: #FFFFFF;
    border: none;
    outline: none;
    box-shadow: none;
    width: 23px;
    height: 23px;
    box-sizing: border-box;
    padding: 12px 17px 12px;
    border-radius: 50%;
  }
  @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-lg) {
    .events-sidebar__button-item {
      display: block;
    }
  }
</style>
